import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

import { IBoxLogo, LinkButton, StatusPill } from "./ui";

const navItems = [
  { label: "APPS", href: "/#apps" },
  { label: "PRICING", href: "/#pricing" },
  { label: "DOCS", href: "/docs/" },
];

export function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed left-0 right-0 top-0 z-50 border-b transition-all duration-300 ${
        scrolled ? "border-border bg-bg/90 backdrop-blur-md" : "border-transparent bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6">
        <a href="/" className="flex items-center gap-4" aria-label="iBox home">
          <IBoxLogo className="h-6 md:h-7" />
          <span className="hidden h-5 w-px bg-border md:inline-block" />
          <StatusPill status="success" label="v2.4 LIVE" pulse className="hidden md:inline-flex" />
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {navItems.map((item) => (
            <a
              key={item.label}
              href={item.href}
              className="rounded-md px-4 py-2 text-[11px] font-semibold tracking-[0.25em] text-muted transition-colors hover:bg-surface hover:text-text"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <LinkButton href="/account" variant="ghost" size="sm">
            ACCOUNT
          </LinkButton>
          <LinkButton href="/download" size="sm">
            GET IBOX
          </LinkButton>
        </div>

        <button
          aria-label="Toggle menu"
          className="p-2 text-text md:hidden"
          onClick={() => setMobileMenuOpen((open) => !open)}
          type="button"
        >
          {mobileMenuOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {mobileMenuOpen ? (
        <div className="absolute left-0 right-0 top-16 flex flex-col gap-4 border-b border-border bg-surface p-6 md:hidden">
          {navItems.map((item) => (
            <a
              key={item.label}
              href={item.href}
              className="py-2 text-sm font-semibold tracking-[0.25em] text-text"
              onClick={() => setMobileMenuOpen(false)}
            >
              {item.label}
            </a>
          ))}
          <div className="flex flex-col gap-3 border-t border-border pt-4">
            <LinkButton href="/account" variant="ghost" className="w-full">
              ACCOUNT
            </LinkButton>
            <LinkButton href="/download" className="w-full">
              GET IBOX
            </LinkButton>
          </div>
        </div>
      ) : null}
    </header>
  );
}
